import React from 'react'
import { Span, styled, Flex } from '@fareye/ui'
import { isEmpty } from '@fareye/utils'
import { dateFormatter, useTranslation } from '@fareye/common'
interface ITable {
  label: string
  key: string
  dateTimeObj?: any
}
interface ITimeLineTable {
  columns: ITable[]
  data: any[]
}
const Table = styled.table`
  margin: 5px;
  border-spacing: 20px 0;
`
const TH = styled.th`
  font-size: 11px;
  font-weight: 500;
  color: #212121;
  text-align: left;
  padding: 6px 0px;
`
const TD = styled.td`
  font-size: 12px;
  color: #727272;
  padding: 6px 0px;
`
const TruncatedText = styled.span`
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 32px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`
export default function TimeLineTable(props: ITimeLineTable) {
  const { columns, data } = props
  const length = columns.length
  const { t } = useTranslation()
  const keysDataToTranslate = ['activity', 'status']
  return (
    <>
      {!isEmpty(data) ? (
        <Table>
          <thead>
            <tr>
              {columns.map(ele => {
                return <TH key={ele.key}>{t(ele.label)}</TH>
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((element, index) => {
              return (
                <tr key={`row${index}`}>
                  {columns.map((ele, index) => {
                    if (ele.key == 'dateTime') {
                      if (!element.dateTimeObj) {
                        element.dateTimeObj = element[ele.key]
                      }
                      element[ele.key] =
                        typeof element.dateTimeObj == 'object'
                          ? dateFormatter(element.dateTimeObj)
                          : element.dateTimeObj
                    }
                    return (
                      <TD
                        key={`value${ele.key}${index}`}
                        style={{
                          width: index < length - 1 ? '151px' : 'auto',
                          verticalAlign: 'top'
                        }}
                        title={element[ele.key] ? element[ele.key] : '-'}
                      >
                        {element[ele.key] ? (
                          <TruncatedText>
                            {keysDataToTranslate.includes(ele.key)
                              ? t(element[ele.key])
                              : element[ele.key]}
                          </TruncatedText>
                        ) : (
                          '-'
                        )}
                      </TD>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      ) : (
        <Flex p={15} alignItemsCenter>
          <Span style={{ fontSize: '14px', fontWeight: '500' }}>
            {`${t('No Data Found')}...`}
          </Span>
        </Flex>
      )}
    </>
  )
}
